// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"EW-z","sponsoredTooltipWrapper":"FW-z","sponsoredTooltip":"GW-z","newCard":"HW-z"};